import React, { useState } from 'react';
import { useStringsContext } from '../../../../contexts/strings';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { PushNotificationType } from '../types';
import svStrings from '../../../../sv-strings';

interface Props {
  onSelectedType: (selectedType: PushNotificationType) => void;
}

interface PushNotificationSelection {
  value: PushNotificationType;
  label: string;
}

const pushNotificationSelections: PushNotificationSelection[] = [
  { value: 'scheduled', label: svStrings.pushNotifications.labelScheduled },
  { value: 'team-news', label: svStrings.pushNotifications.labelNews },
  { value: 'match-event', label: svStrings.pushNotifications.labelMatchEvents },
  {
    value: 'match-event_highlights_plus',
    label: svStrings.pushNotifications.labelMatchEventsHiglightsPlus,
  },
];

const SelectType = ({ onSelectedType }: Props) => {
  const { strings } = useStringsContext();
  const [selectedType, setSelectedType] = useState<PushNotificationType>(
    pushNotificationSelections[0].value
  );

  const onChange = (event: SelectChangeEvent) => {
    const newSelectedType = event.target.value as PushNotificationType;
    setSelectedType(newSelectedType);
    onSelectedType(newSelectedType);
  };

  return (
    <FormControl fullWidth>
      <InputLabel size="small">{strings.pushNotifications.selectType}</InputLabel>
      <Select
        size="small"
        value={selectedType}
        label={pushNotificationSelections[0].label}
        onChange={onChange}
      >
        {pushNotificationSelections.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectType;
